var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "my-3"
  }, [_vm._v("Input Multiple")]), _c('h4', [_vm._v("Current comments are: " + _vm._s(_vm.comments))]), _c('FormItemInputMultiple', {
    attrs: {
      "placeholder": 'Add keyword'
    },
    model: {
      value: _vm.comments,
      callback: function callback($$v) {
        _vm.comments = $$v;
      },
      expression: "comments"
    }
  })], 1), _c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "my-3"
  }, [_vm._v("Checkboxes")]), _c('h4', [_vm._v("Current toppings are: " + _vm._s(_vm.toppings))]), _c('BaseCheckbox', {
    attrs: {
      "label": "Pepperoni",
      "input-value": "pepperoni"
    },
    model: {
      value: _vm.toppings,
      callback: function callback($$v) {
        _vm.toppings = $$v;
      },
      expression: "toppings"
    }
  }), _c('BaseCheckbox', {
    attrs: {
      "label": "Garlic",
      "input-value": "garlic"
    },
    model: {
      value: _vm.toppings,
      callback: function callback($$v) {
        _vm.toppings = $$v;
      },
      expression: "toppings"
    }
  }), _c('BaseCheckbox', {
    attrs: {
      "label": "Cheese",
      "input-value": "cheese"
    },
    model: {
      value: _vm.toppings,
      callback: function callback($$v) {
        _vm.toppings = $$v;
      },
      expression: "toppings"
    }
  }), _c('BaseCheckbox', {
    attrs: {
      "label": "Oregano",
      "input-value": "oregano"
    },
    model: {
      value: _vm.toppings,
      callback: function callback($$v) {
        _vm.toppings = $$v;
      },
      expression: "toppings"
    }
  }), _c('br'), _c('h4', [_vm._v("Current names are: " + _vm._s(_vm.names))]), _c('BaseCheckbox', {
    attrs: {
      "label": "John",
      "input-value": "John"
    },
    model: {
      value: _vm.names,
      callback: function callback($$v) {
        _vm.names = $$v;
      },
      expression: "names"
    }
  }), _c('BaseCheckbox', {
    attrs: {
      "label": "Rey",
      "input-value": "Rey"
    },
    model: {
      value: _vm.names,
      callback: function callback($$v) {
        _vm.names = $$v;
      },
      expression: "names"
    }
  }), _c('BaseCheckbox', {
    attrs: {
      "label": "Donald",
      "input-value": "Donald"
    },
    model: {
      value: _vm.names,
      callback: function callback($$v) {
        _vm.names = $$v;
      },
      expression: "names"
    }
  }), _c('BaseCheckbox', {
    attrs: {
      "label": "Julie",
      "input-value": "Julie"
    },
    model: {
      value: _vm.names,
      callback: function callback($$v) {
        _vm.names = $$v;
      },
      expression: "names"
    }
  })], 1), _c('div', {
    staticClass: "col mb-5"
  }, [_c('h2', {
    staticClass: "my-3"
  }, [_vm._v("Multiselect")]), _c('h4', [_vm._v("Current Music Object is: " + _vm._s(_vm.selectedMusicObjects))]), _c('BaseMultiSelect', {
    attrs: {
      "options": _vm.musicStylesObject,
      "option-text": 'label',
      "placeholder": 'Select...'
    },
    model: {
      value: _vm.selectedMusicObjects,
      callback: function callback($$v) {
        _vm.selectedMusicObjects = $$v;
      },
      expression: "selectedMusicObjects"
    }
  })], 1), _c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "my-3"
  }, [_vm._v("Radio Button")]), _c('h4', [_vm._v("Current Soda Flavor is: " + _vm._s(_vm.sodaFlavor))]), _c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_c('BaseRadioButton', {
    attrs: {
      "label": "Orange",
      "name": "sodaFlavorButton",
      "value": "orange"
    },
    model: {
      value: _vm.sodaFlavor,
      callback: function callback($$v) {
        _vm.sodaFlavor = $$v;
      },
      expression: "sodaFlavor"
    }
  }), _c('BaseRadioButton', {
    attrs: {
      "label": "Grape",
      "name": "sodaFlavorButton",
      "value": "grape"
    },
    model: {
      value: _vm.sodaFlavor,
      callback: function callback($$v) {
        _vm.sodaFlavor = $$v;
      },
      expression: "sodaFlavor"
    }
  })], 1), _c('br'), _c('h4', [_vm._v("Current Soup Flavor is: " + _vm._s(_vm.soupFlavor))]), _c('div', {
    staticStyle: {
      "width": "400px"
    }
  }, [_c('BaseRadioButton', {
    attrs: {
      "label": "Tomato",
      "name": "soupFlavorButton",
      "value": "tomato"
    },
    model: {
      value: _vm.soupFlavor,
      callback: function callback($$v) {
        _vm.soupFlavor = $$v;
      },
      expression: "soupFlavor"
    }
  }), _c('BaseRadioButton', {
    attrs: {
      "label": "Pumpkin",
      "name": "soupFlavorButton",
      "value": "pumpkin"
    },
    model: {
      value: _vm.soupFlavor,
      callback: function callback($$v) {
        _vm.soupFlavor = $$v;
      },
      expression: "soupFlavor"
    }
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col my-3"
  }, [_c('h1', [_vm._v("Form Components")])]);
}]

export { render, staticRenderFns }